module.exports = __webpack_public_path__ + "img/avatar.4fc78dae.png";